import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DataTableTemplate from "../Components/DataTableTemplate";
import * as yup from "yup";
import { PanelContainer } from "../Components/PanelContainer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomAddCoinModal from "../Components/CustomAddCoinModal";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import {
  fetchData,
  formatNumber,
  getFilterButton,
  getFilterClearButton,
  getFilterDate,
  getFilterSelect,
} from "../Components/Utilities";
import { Button } from "react-bootstrap";
import Cookies from "js-cookie";
import { useForm } from "react-hook-form";
import ConvertCoinToRlsModal from "../Components/ConvertCoinToRlsModal";
import InComeCoinModal from "../Components/InComeCoinModal";
import OutComeCoinModal from "../Components/OutComeCoinModal";
export const CoinFund = () => {
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const { userId } = useParams();
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isCoinToRlsModalOpen, setIsCoinToRlsModalOpen] = useState(false);
  const [isRlsToCoinModalOpen, setIsRlsToCoinModalOpen] = useState(false);
  const [isInComeCoinModalOpen, setIsInComeCoinModalOpen] = useState(false);
  const [isOutComeCoinModalOpen, setIsOutComeCoinModalOpen] = useState(false);
  const [coinFund, setOpenCoinFund] = useState(true);
  const [rialFund, setOpenRialFund] = useState(false);
  const [remainCoins, setRemainCoins] = useState("");
  const [typeList, setTypeList] = useState([]);
  const coinRef = React.useRef(null);
  const rialRef = React.useRef(null);
  const navigate = useNavigate();
  const defaultValues = {};
  const {
    handleSubmit,
    control,
    reset,
    register,
    setValue,
    watch,
    formState: { errors },
  } = useForm({ defaultValues });
  const handleTypeApiResponse = (data) => {
    const mapCats = (apiResponse) => {
      return apiResponse?.map((item) => ({
        value: item.id.toString(),
        label: item.groupname,
      }));
    };
    const formattedOptions = mapCats(data?.dt);
    setTypeList(formattedOptions);
  };
  useEffect(() => {
    // Scroll to the edit component when it becomes visible

    if (rialFund && rialRef.current) {
      rialRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [rialFund]);

  const closeConinToRlsModal = () => {
    setIsCoinToRlsModalOpen(false);
  };
  const closeIncomeCoinModal = () => {
    setIsInComeCoinModalOpen(false);
  };
  const closeOutcomeCoinModal = () => {
    setIsOutComeCoinModalOpen(false);
  };
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultDatatableRows,
    filters: {
      ckDate: { value: "", matchMode: "contains" },
      Mob: { value: "", matchMode: "contains" },
      typename: { value: null, matchMode: FilterMatchMode.IN },
      sex: { value: null, matchMode: FilterMatchMode.IN },
      org: { value: null, matchMode: FilterMatchMode.IN },
    },
  });

  const cols = [
    {
      field: "ckDate",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    {
      field: "ckDate",
      header: "تاریخ",
      sortable: true,
      filter: true,
      filterPlaceholder: "نام را وارد کنید",
      showFilterMatchModes: false,
      showFilterOperator: false,
      filterApply: getFilterButton,
      filterElement: (options) =>
        // getFilterInputText(options, "نام یا نام خانوادگی را وارد کنید..."),
        getFilterDate(options, "", watch, control),
      filterClear: getFilterClearButton,
    },
    { field: "ckTime", header: "زمان" },
    {
      field: "ckIn",
      header: "سکه دریافتی",
      body: (data) => (
        <p style={{ direction: "ltr", textAlign: "center" }}>
          {formatNumber(data?.ckIn)}
        </p>
      ),
    },
    {
      field: "ckOut",
      header: "سکه خرج شده",
      body: (data) => (
        <p style={{ direction: "ltr", textAlign: "center" }}>
          {formatNumber(data?.ckOut)}
        </p>
      ),
    },
    {
      field: "remain",
      header: "باقیمانده",
      body: (data) => (
        <p style={{ direction: "ltr", textAlign: "center" }}>
          {formatNumber(data?.remain)}
        </p>
      ),
    },
    {
      field: "typename",
      header: "نوع",
      body: (data) => data.typename,
      filter: true,
      filterPlaceholder: "گروه را انتخاب کنید",
      showFilterMatchModes: false,
      filterApply: getFilterButton,
      filterElement: (options) =>
        getFilterSelect(
          options,
          typeList,
          "groupid",
          "نوع عملیات را انتخاب کنید"
        ),
      filterClear: getFilterClearButton,
    },
    { field: "ckDesc", header: "توضیحات" },
  ];

  const openReceipt = () => {
    // setReceiptModalOpen(true); //
  };
  const onFilter = (event) => {
    event["first"] = 0;
    setLazyState((cur) => ({ ...cur, ...event }));
    console.log(event, "on filter");
  };
  const schema = yup.object({
    CatId: yup.string().required("دسته بندی انتخاب نشده است."),
    ManagerId: yup.string().required("مدیر انتخاب نشده است."),
  });
  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("uid", -1);
    bodyFormData.append("pageNo", lazyState?.page + 1 ?? 1);
    bodyFormData.append("pageSize", lazyState?.rows ?? 20);
    fetchData("mycoin", bodyFormData, handleApiResponse);
    fetchData("cointype", bodyFormData, handleTypeApiResponse);
  }, []);
  const onPage = (event) => {
    setLazyState((cur) => ({ ...cur, ...event }));
    setDefaultDatatableRows(event.rows);
  };
  let networkTimeout = null;
  useEffect(() => {
    loadLazyData(lazyState);
  }, [lazyState]);

  const loadLazyData = (data) => {
    setLoading(true);
    if (networkTimeout) {
      clearTimeout(networkTimeout);
    }

    //imitate delay of a backend call
    networkTimeout = setTimeout(() => {
      const bodyFormData = new FormData();
      bodyFormData.append("guid", Cookies.get("guid"));
      bodyFormData.append("pageNo", data?.page + 1 ?? 1);
      bodyFormData.append("pageSize", data?.rows ?? 20);
      if (data?.filters?.name?.value) {
        bodyFormData.append("name", data?.filters?.name?.value);
      }
      if (data?.filters?.groupid?.value) {
        bodyFormData.append("groupid", data?.filters?.groupid?.value);
      }
      if (data?.filters?.sex?.value) {
        bodyFormData.append("sex", data?.filters?.sex?.value);
      }
      if (data?.filters?.Mob?.value) {
        bodyFormData.append("mob", data?.filters?.Mob?.value);
      }
      if (data?.filters?.org?.value) {
        bodyFormData.append("org", data?.filters?.org?.value);
      }
      const handleApiResponse = (data) => {
        setTotalRecords(data?.count);
        setUserList(data?.dt);
        setLoading(false);
      };
      fetchData("mycoin", bodyFormData, handleApiResponse);
    }, Math.random() * 1000 + 250);
  };

  const handleApiResponse = (data) => {
    setUserList(data?.dt);
    setTotalRecords(data?.count);
    setRemainCoins(data?.tCoin);
  };
  const handleConvertCoinToRls = (data) => {
    setIsCoinToRlsModalOpen(true);
  };
  const handleConvertRlsToCoin = (data) => {
    setIsRlsToCoinModalOpen(true);
  };
  const exportExcel = () => {
    console.log("first");
    import("xlsx").then((xlsx) => {
      const excelList = userList.map((item) => ({
        تاریخ: item.ckDate,
        "سکه دریافتی": item.ckIn,
        "سکه خرج شده": item.ckOut,
        " باقیمانده": item.remain,
        "نوع عملیات": item.typename,
        توضیحات: item.ckDesc,
      }));
      const worksheet = xlsx.utils.json_to_sheet(excelList);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "products");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };

  const headerTaab30 = (
    <div className="d-flex align-items-center justify-content-between dt-header flex-wrap">
      <div className="d-flex align-items-center justify-content-between gap-1 ">
        <FontAwesomeIcon
          onClick={exportExcel}
          className=" p-2 rounded bg-info text-white  cursor-pointer"
          icon={"file-excel"}
        />
        <div className="">
          <Button
            className=" btn btn-primary "
            onClick={handleConvertCoinToRls}
          >
            <span>تبدیل پارسی به ریال</span>
            <span
              dir="rtl"
              style={{ direction: "ltr", textAlign: "center" }}
            ></span>
          </Button>
        </div>
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-1">
          <Button
            type={"button"}
            className="btn-success"
            onClick={() => setIsInComeCoinModalOpen(true)}
          >
            دریافت سکه
          </Button>
          <Button
            type={"button"}
            className="btn-info"
            onClick={() => setIsOutComeCoinModalOpen(true)}
          >
            پرداخت سکه
          </Button>
        </div>
      </div>
      <div className=" ">
        <span> سکه های موجود </span>
        <span
          className="text-danger"
          dir="rtl"
          style={{ direction: "ltr", textAlign: "center" }}
        >
          {formatNumber(remainCoins)}
        </span>
      </div>
    </div>
  );

  return (
    <>
      {/* Coin */}
      <ConvertCoinToRlsModal
        isOpen={isCoinToRlsModalOpen}
        closeModal={closeConinToRlsModal}
        userId={userId}
      />
      <InComeCoinModal
        isOpen={isInComeCoinModalOpen}
        closeModal={closeIncomeCoinModal}
        userId={userId}
        body={true}
      />
      <OutComeCoinModal
        isOpen={isOutComeCoinModalOpen}
        closeModal={closeOutcomeCoinModal}
        userId={userId}
        body={true}
      />
      <PanelContainer title={"صندوق تاب30"}>
        <div className="row text-right  p-sm-0  data-table">
          <div className="card-panel">
            <DataTableTemplate
              lazyState={lazyState}
              lazy
              className={"table-border"}
              columns={cols}
              list={userList}
              totalRecords={totalRecords}
              setlazyState={setLazyState}
              defaultDatatableRows={defaultDatatableRows}
              width="25rem"
              header={headerTaab30}
              loading={loading}
              filters={lazyState.filters}
              onPage={onPage}
              onFilter={onFilter}
            />
          </div>
        </div>
      </PanelContainer>
    </>
  );
};
